exports.install = function (Vue, store, router) {
  if (this.installed) {
    return
  }

  this.installed = true

  router.beforeEach(function (to, from, next) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(from.path, '=>', to.path)
    }

    next()
  })
}



// WEBPACK FOOTER //
// ./src/configs/guards/index.js